var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgColumns = function SvgColumns(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4916_255516)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 21,
    width: 18,
    height: 4,
    transform: "rotate(-90 3 21)",
    fill: "var(--iconColor, currentColor)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 21,
    width: 18,
    height: 4,
    transform: "rotate(-90 10 21)",
    fill: "var(--iconColor, currentColor)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 21,
    width: 18,
    height: 4,
    transform: "rotate(-90 17 21)",
    fill: "var(--iconColor, currentColor)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4916_255516"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "matrix(0 -1 1 0 0 24)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgColumns);
export { ForwardRef as ReactComponent };